module.exports = __webpack_public_path__ + "static/media/error-404.1a807f0e.png";